import React from 'react';
import SectionLayout from './SectionLayout/SectionLayout';
import ProjectsList from './Projects/ProjectsList';

const Projects = ({ lang, projectSection, projects }) => {
  const { title, description } = projectSection;

  return (
    <SectionLayout id="projects" title={title} description={description}>
      <ProjectsList projects={projects} lang={lang} />
    </SectionLayout>
  );
};

export default Projects;